/**
 * SEO Data Formatters Module
 * Handles entity data formatting for SEO optimization
 * Part of SEO optimization - follows AIM atomicity principle
 */

import { generatePageTitle, generateMetaDescription, generateCanonicalUrl, generateKeywords } from './meta'

/**
 * Format entity data for SEO
 */
export const formatEntityForSEO = (entity) => {
  if (!entity) return null

  const currentAddress = entity.currentAddress || entity.current_address
  const imageUrl = entity.imageURL || entity.imageUrl
  const baseUrl = import.meta.env.VITE_SITE_URL || 'http://localhost:3001'
  
  const title = `${entity.name}${currentAddress ? ` - ${currentAddress}` : ''}`
  const locationText = currentAddress
    ? `last spotted at ${currentAddress}`
    : `a mobile ${entity.category || 'vendor'}`
  const description = entity.description ||
    `Track ${entity.name} — ${locationText}. See live locations and community sightings on TrckIt.`

  return {
    title: generatePageTitle(title),
    description: generateMetaDescription(description),
    keywords: generateKeywords(entity),
    canonical: generateCanonicalUrl(`/entities/${entity.id}`),
    image: imageUrl ? (imageUrl.startsWith('http') ? imageUrl : `${baseUrl}${imageUrl}`) : `${baseUrl}/logo.png`,
  }
}
